const COLORS = {
  PRIMARY_WHITE: "#ffffff",
  COLOR_DARK: "#293461",
  HEADER_BORDER: "#e1e3ee",
  BTN_GREEN: "#00838c",
  BORDER_GREY: "#e1e3ee",
  TABLE_GREY_CELL: "#f4f6ff",
  HYPERLINK: "#007aff",
  INPUT_BACKGROUND: "#f9f9f9",
  INPUT_BORDER: "#e1e3ee",
  INPUT_LABEL: "#949ab0",
  LOGOUT_RED: "#d91b1b",
  PEENDIGN_ACTION_LINK: "#00838c",
  WARNING_COLOR: "#e89a14",
  ERROR_COLOR: "ff3c3c",
  ADD_NOTE_TEXT_AREA: "#f8faff",
  BOX_BLUE: "#0000FF",
  BOX_DARKGREEN: "#006400",
  BOX_DEEPPINK: "#FF1493",
  BOX_DARKMAGENTA: "#8B008B",
  BOX_INDIGO: "#4B0082",
  BOX_OLIVE: "#808000",
  INPUT_GRAY: "#aaaaaa",
  TRANSCRIPT_GRAY: "#8294a5",
  HIGHLIGHT_COLOR: "#69e3c2"
};

export default COLORS;
